import { render, staticRenderFns } from "./CustomTypeBox.vue?vue&type=template&id=46b21187&"
import script from "./CustomTypeBox.vue?vue&type=script&lang=js&"
export * from "./CustomTypeBox.vue?vue&type=script&lang=js&"
import style0 from "./CustomTypeBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
